<template>
  <div class="setting-page d-flex flex-column">
    <div class="setting-page__inner">
      <!-- Profile -->
      <section class="setting-profile-card">
        <div class="setting-profile-card__glow" aria-hidden="true" />
        <div class="setting-profile-card__body">
          <div class="setting-avatar-wrap">
            <img
              class="setting-avatar"
              src="https://storage.googleapis.com/spacetech2/cr7/assets/logo.avif"
              alt=""
            >
          </div>
          <div class="setting-profile-info">
            <p class="setting-profile-info__label">
              {{ $t('setting.name') }}
            </p>
            <h1 class="setting-profile-info__name">
              {{ $store.state.authUser.name }}
            </h1>
            <p class="setting-profile-info__username">
              @{{ $store.state.authUser.user_name }}
            </p>
          </div>
        </div>
        <dl class="setting-stat-grid">
          <div class="setting-stat">
            <dt class="setting-stat__label">
              {{ $t('setting.balance') }}
            </dt>
            <dd class="setting-stat__value">
              {{ Number($store.state.amount).toLocaleString() }}
              <span class="setting-stat__unit">MMK</span>
            </dd>
          </div>
          <div class="setting-stat">
            <dt class="setting-stat__label">
              {{ $t('setting.withdraw') }}
            </dt>
            <dd class="setting-stat__value">
              {{ Number($store.state.totalWithdraw).toLocaleString() }}
              <span class="setting-stat__unit">MMK</span>
            </dd>
          </div>
          <div class="setting-stat setting-stat--full">
            <dt class="setting-stat__label">
              {{ $t('setting.phone') }}
            </dt>
            <dd class="setting-stat__value setting-stat__value--mono">
              {{ blurLastFiveCharacters($store.state.authUser.phone) }}
            </dd>
          </div>
        </dl>
      </section>

      <!-- Quick actions -->
      <section class="setting-quick-actions" aria-label="Shortcuts">
        <button
          type="button"
          class="setting-quick-actions__btn"
          @click="$router.push('/deposit')"
        >
          <span class="setting-quick-actions__icon-wrap">
            <img
              src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/deposit-ak47-new.png"
              alt=""
            >
          </span>
          <span class="setting-quick-actions__label">{{ $t('setting.deposit') }}</span>
        </button>
        <button
          type="button"
          class="setting-quick-actions__btn"
          @click="$router.push('/withdraw')"
        >
          <span class="setting-quick-actions__icon-wrap">
            <img
              src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/withdraw-ak47-new.png"
              alt=""
            >
          </span>
          <span class="setting-quick-actions__label">{{ $t('setting.withdraw') }}</span>
        </button>
        <button
          type="button"
          class="setting-quick-actions__btn"
          @click="$router.push('/promotion')"
        >
          <span class="setting-quick-actions__icon-wrap">
            <img
              src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/promotion-ak47-new.png"
              alt=""
            >
          </span>
          <span class="setting-quick-actions__label">{{ $t('footer.promotion') }}</span>
        </button>
        <button
          type="button"
          class="setting-quick-actions__btn"
          @click="$router.push('/history')"
        >
          <span class="setting-quick-actions__icon-wrap">
            <img
              src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/history-ak47-new.png"
              alt=""
            >
          </span>
          <span class="setting-quick-actions__label">{{ $t('setting.transaction') }}</span>
        </button>
      </section>

      <!-- Settings menu -->
      <nav class="setting-menu-card" aria-label="Account settings">
        <ul class="setting-menu-list">
          <li
            class="setting-menu-item"
            role="button"
            tabindex="0"
            @click="openPasswordModal"
            @keyup.enter="openPasswordModal"
          >
            <div class="setting-menu-item__main">
              <span class="setting-menu-item__icon">
                <img
                  src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/reset-password--new-ak47.png"
                  alt=""
                >
              </span>
              <span class="setting-menu-item__text">{{ $t('setting.update_password') }}</span>
            </div>
            <i class="fas fa-chevron-right setting-menu-item__chevron" />
          </li>
          <li
            class="setting-menu-item"
            @click="() => $router.push('/banking')"
          >
            <div class="setting-menu-item__main">
              <span class="setting-menu-item__icon">
                <img
                  src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-bank.png"
                  alt=""
                >
              </span>
              <span class="setting-menu-item__text">{{ $t('setting.bank_account') }}</span>
            </div>
            <i class="fas fa-chevron-right setting-menu-item__chevron" />
          </li>
        </ul>

        <ul class="setting-menu-list setting-menu-list--lang">
          <li class="setting-lang-item">
            <div class="dropdown w-100">
              <div
                id="navbar-language"
                class="setting-menu-item setting-lang-item__toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div class="setting-menu-item__main">
                  <span class="setting-menu-item__icon">
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-language.png"
                      alt=""
                    >
                  </span>
                  <span class="setting-menu-item__text">{{ $t('setting.update_language') }}</span>
                </div>
                <i class="fas fa-chevron-right setting-menu-item__chevron" />
              </div>
              <div
                class="dropdown-menu dropdown-menu-right w-100 setting-lang-dropdown"
                aria-labelledby="navbar-language"
              >
              <a
                class="dropdown-item setting-lang-dropdown__item"
                href="#"
                @click.prevent="setLangLocalstorage('en')"
              ><img
                src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png"
                alt=""
                class="mr-2"
              >{{ $t('en') }}</a>
              <div class="dropdown-divider setting-lang-dropdown__divider" />
              <a
                class="dropdown-item setting-lang-dropdown__item"
                href="#"
                @click.prevent="setLangLocalstorage('mm')"
              ><img
                src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png"
                alt=""
                class="mr-2"
              >{{ $t('mm') }}</a>
              <div class="dropdown-divider setting-lang-dropdown__divider" />
              <a
                class="dropdown-item setting-lang-dropdown__item"
                href="#"
                @click.prevent="setLangLocalstorage('cn')"
              ><img
                src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png"
                alt=""
                class="mr-2"
              >{{ $t('cn') }}</a>
              <div class="dropdown-divider setting-lang-dropdown__divider" />
              <a
                class="dropdown-item setting-lang-dropdown__item"
                href="#"
                @click.prevent="setLangLocalstorage('th')"
              ><img
                src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png"
                alt=""
                class="mr-2"
              >{{ $t('th') }}</a>
              </div>
            </div>
          </li>
        </ul>

        <div class="setting-menu-footer">
          <button
            type="button"
            class="setting-logout-btn"
            @click="logout()"
          >
            <img
              src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-logout.png"
              alt=""
            >
            <span>{{ $t('setting.logout') }}</span>
          </button>
        </div>
      </nav>
    </div>

    <!-- Password sheet: van-popup mounts to body — avoids broken fixed/touch inside nested scroll (mobile) -->
    <van-popup
      v-model="showPasswordModal"
      position="center"
      round
      get-container="body"
      class="setting-password-popup"
      :style="{ width: 'min(28rem, calc(100vw - 1rem))' }"
      :close-on-click-overlay="true"
    >
      <div class="setting-password-modal__content">
        <div class="setting-password-modal__header border-0">
          <h5
            id="setting-password-modal-title"
            class="setting-password-modal__title mb-0"
          >
            {{ $t('setting.update_password') }}
          </h5>
          <button
            type="button"
            class="close setting-password-modal__close text-white"
            aria-label="Close"
            @click="closePasswordModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="setting-password-modal__body">
          <div class="setting-password-field">
            <label class="setting-password-field__label">{{ $t('setting.old_password') }}</label>
            <input
              v-model="password.old"
              type="password"
              class="form-control setting-password-field__input"
              autocomplete="current-password"
            >
            <span class="text-danger setting-password-field__error">{{ errors.old }}</span>
          </div>
          <div class="setting-password-field">
            <label class="setting-password-field__label">{{ $t('setting.new_password') }}</label>
            <input
              v-model="password.new"
              type="password"
              class="form-control setting-password-field__input"
              autocomplete="new-password"
            >
            <span class="text-danger setting-password-field__error">{{ errors.new }}</span>
          </div>
          <div class="setting-password-field">
            <label class="setting-password-field__label">{{ $t('setting.confirm_password') }}</label>
            <input
              v-model="password.confirm"
              type="password"
              class="form-control setting-password-field__input"
              autocomplete="new-password"
            >
            <span class="text-danger setting-password-field__error">{{
              errors.confirm || errors.confirmPassword
            }}</span>
          </div>
          <button
            type="button"
            class="btn setting-password-modal__submit w-100"
            @click="changeNewPassword"
          >
            <template v-if="!isConfirm">
              {{ $t('setting.update') }}
            </template>
            <Loading
              v-else
              color="#ffffff"
              size="24"
              class="px-4 py-0"
            />
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      password: {
        user_id: this.$store.state.authUser.id,
      },
      isConfirm: false,
      errors: {},
      isCollecting: false,
      showPasswordModal: false,
    };
  },
  methods: {
    openPasswordModal() {
      this.errors = {};
      this.showPasswordModal = true;
    },
    closePasswordModal() {
      this.showPasswordModal = false;
    },
    async collectAmount() {
      try {
        this.isCollecting = true;
        await axios.get('/claim-loss-return',
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        this.fetchUser();
        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success!'
            : 'Success!'
        );
        this.isCollecting = false;
      } catch (error) {
        this.isCollecting = false;
        Toast.fail(
          this.$store.state.language === 'en'
            ? 'Fail!'
            : 'Fail!'
        );
      }
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    blurLastFiveCharacters(inputString = '0000000000') {
      const length = inputString.length;
      if (length >= 7) {
        const firstPart = inputString.substring(length - 5, length);
        const blurredCharacters = '*'.repeat(length - 5);
        return blurredCharacters + firstPart;
      }
      return inputString;
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language;
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old =
          this.$store.state.language === 'en'
            ? 'Old password required'
            : 'လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။';
        return false;
      }
      if (!this.password.new) {
        this.errors.new =
          this.$store.state.language === 'en'
            ? 'New password required'
            : 'လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။';
        return false;
      }
      if (!this.password.confirm) {
        this.errors.confirm =
          this.$store.state.language === 'en'
            ? 'Confirm password required'
            : 'အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။';
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword =
          this.$store.state.language === 'en'
            ? 'New passwords not match'
            : 'လျှို့ဝှက်နံပါတ် မတူညီပါ။';
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure?'
            : 'သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မလုပ်တော့ပါ။',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ။',
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => {});
      this.isConfirm = false;
      return true;
    },
    async updateUser() {
      try {
        await axios.post(
          '/auth/userPasswordChange',
          this.password,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        Toast.success(
          this.$store.state.language === 'en' ? 'Success' : 'အောင်မြင်သည်။'
        );
        this.password = { user_id: this.$store.state.authUser.id };
        this.errors = {};
        this.showPasswordModal = false;
      } catch (error) {
        Toast.fail(
          this.$store.state.language === 'en' ? 'Fail' : 'ကျရှုံးသည်။'
        );
      }
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path === '/home') {
          } else {
            this.$router.push('/home');
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => {});
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
  },
};
</script>
<style scoped lang="scss">
$setting-accent: #f06126;
$setting-accent-soft: rgba(240, 97, 38, 0.15);
$setting-border: #2e2a24;
$setting-surface: #161616;
$setting-elevated: #1c1b18;

.setting-page {
  width: 100%;
  min-height: 100vh;
  /* Scroll only on parent (.index-router-view); nested overflow breaks fixed overlays on iOS */
  overflow-x: hidden;
  overflow-y: visible;
  padding: 0.75rem 0.85rem 6rem;
  box-sizing: border-box;
  background: radial-gradient(ellipse 120% 80% at 50% -20%, rgba(240, 97, 38, 0.12), transparent 55%),
    linear-gradient(180deg, #121212 0%, #0c0c0c 100%);
  color: #fff;
}

.setting-page__inner {
  width: 100%;
  max-width: none;
  margin: 0 auto;
}

.setting-profile-card {
  position: relative;
  overflow: hidden;
  background: $setting-surface;
  border: 1px solid $setting-border;
  border-radius: 12px;
  padding: 1.25rem 1rem 1rem;
  margin-bottom: 0.875rem;
}

.setting-profile-card__glow {
  position: absolute;
  top: -40%;
  right: -20%;
  width: 60%;
  height: 80%;
  background: radial-gradient(circle, $setting-accent-soft 0%, transparent 70%);
  pointer-events: none;
}

.setting-profile-card__body {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.125rem;
}

.setting-avatar-wrap {
  flex-shrink: 0;
  padding: 3px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(240, 97, 38, 0.5), rgba(213, 194, 152, 0.35));
}

.setting-avatar {
  display: block;
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  object-fit: cover;
  background: #0a0a0a;
}

.setting-profile-info__label {
  margin: 0 0 0.15rem;
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);
}

.setting-profile-info__name {
  margin: 0 0 0.2rem;
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.25;
  color: #fff;
}

.setting-profile-info__username {
  margin: 0;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
}

.setting-stat-grid {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem 0.75rem;
  margin: 0;
  padding: 0.85rem 0 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.setting-stat {
  margin: 0;
  padding: 0.55rem 0.65rem;
  background: $setting-elevated;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.setting-stat--full {
  grid-column: 1 / -1;
}

.setting-stat__label {
  margin: 0 0 0.25rem;
  font-size: 0.68rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.45);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.setting-stat__value {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: #f0ebe3;
  letter-spacing: 0.02em;
}

.setting-stat__value--mono {
  font-weight: 600;
  font-size: 0.88rem;
  letter-spacing: 0.04em;
}

.setting-stat__unit {
  margin-left: 0.25rem;
  font-size: 0.72rem;
  font-weight: 500;
  color: rgba(240, 97, 38, 0.9);
}

.setting-quick-actions {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
  margin-bottom: 0.875rem;
}

.setting-quick-actions__btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.4rem;
  padding: 0.65rem 0.25rem;
  border: 1px solid $setting-border;
  border-radius: 12px;
  background: $setting-surface;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
  -webkit-tap-highlight-color: transparent;

  &:active {
    transform: scale(0.97);
  }

  &:hover,
  &:focus {
    background: $setting-elevated;
    border-color: rgba(240, 97, 38, 0.35);
    outline: none;
  }
}

.setting-quick-actions__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);

  img {
    width: 1.55rem;
    height: 1.55rem;
    object-fit: contain;
  }
}

.setting-quick-actions__label {
  font-size: 0.65rem;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
  color: rgba(255, 255, 255, 0.82);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.setting-menu-card {
  background: $setting-surface;
  border: 1px solid $setting-border;
  border-radius: 12px;
  padding: 0.5rem 0 0.75rem;
  overflow: visible;
}

.setting-menu-list {
  list-style: none;
  margin: 0;
  padding: 0 0.5rem;
}

.setting-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  padding: 0.5rem 0.65rem;
  margin: 0 0 2px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.18s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }

  &:active {
    background: rgba(255, 255, 255, 0.08);
  }
}

.setting-menu-list--lang {
  padding-top: 0.35rem;
  margin-top: 0.35rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.setting-lang-item {
  list-style: none;
  position: relative;
}

.setting-lang-item__toggle {
  width: 100%;
  box-sizing: border-box;
}

.setting-menu-item__main {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.setting-menu-item__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);

  img {
    width: 1.35rem;
    height: 1.35rem;
    object-fit: contain;
  }
}

.setting-menu-item__text {
  font-size: 0.9rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.95);
}

.setting-menu-item__chevron {
  font-size: 0.65rem;
  color: rgba(255, 255, 255, 0.28);
  margin-left: 0.5rem;
}

.setting-lang-dropdown {
  margin-top: 0.25rem !important;
  padding: 0.35rem 0 !important;
  background: $setting-elevated !important;
  border: 1px solid $setting-border !important;
  border-radius: 10px !important;
}

.setting-lang-dropdown__item {
  display: flex;
  align-items: center;
  padding: 0.55rem 1rem !important;
  font-size: 0.88rem;
  color: #eee !important;

  img {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: rgba(240, 97, 38, 0.12) !important;
    color: #fff !important;
  }
}

.setting-lang-dropdown__divider {
  border-color: rgba(255, 255, 255, 0.06) !important;
  margin: 0.15rem 0 !important;
}

.setting-menu-footer {
  padding: 1rem 0.85rem 0.35rem;
  margin-top: 0.25rem;
}

.setting-logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid rgba(181, 2, 0, 0.45);
  border-radius: 12px;
  background: rgba(181, 2, 0, 0.12);
  color: #ff8a84;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;

  img {
    width: 1.35rem;
    height: 1.35rem;
    object-fit: contain;
    opacity: 0.95;
  }

  &:hover,
  &:focus {
    background: rgba(181, 2, 0, 0.2);
    border-color: rgba(181, 2, 0, 0.65);
    outline: none;
  }
}

/* Modal: deep so Bootstrap structure is styled */
.setting-password-modal__content {
  background: #1a1a1a !important;
  border: 1px solid $setting-border !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.setting-password-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 1rem 1.1rem 0.5rem !important;
}

.setting-password-modal__title {
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
}

.setting-password-modal__close {
  margin: 0;
  padding: 0.15rem 0.5rem 0.25rem;
  min-width: 2.75rem;
  min-height: 2.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 2.1rem;
  line-height: 1;
  font-weight: 200;
  opacity: 1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.35);
  background: rgba(0, 0, 0, 0.35);

  &:hover,
  &:focus {
    opacity: 1;
    background: rgba(0, 0, 0, 0.55);
    border-color: rgba(255, 255, 255, 0.55);
    outline: none;
  }
}

.setting-password-modal__body {
  padding: 0.25rem 1.25rem 1.35rem !important;
}

.setting-password-field {
  margin-bottom: 1rem;
}

.setting-password-field__label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.78rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.55);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.setting-password-field__input {
  background: #0d0d0d !important;
  border: 1px solid #333 !important;
  border-radius: 10px !important;
  color: #fff !important;
  height: 44px;
  font-size: 0.95rem;
  box-shadow: none !important;

  &:focus {
    border-color: rgba(240, 97, 38, 0.65) !important;
    box-shadow: none !important;
    outline: none;
  }
}

.setting-password-field__error {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.78rem;
}

.setting-password-modal__submit {
  margin-top: 0.5rem;
  height: 44px !important;
  border: none !important;
  border-radius: 12px !important;
  background: linear-gradient(180deg, lighten($setting-accent, 4%), $setting-accent) !important;
  color: #fff !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;

  &:hover {
    filter: brightness(1.06);
    color: #fff !important;
  }
}
</style>
